// Environment-aware URL configuration
const isProduction = process.env.NODE_ENV === 'production';
const isDevelopment = process.env.NODE_ENV === 'development';

// Base URLs for different environments
const BASE_URLS = {
  // React App (Frontend)
  app: {
    production: 'https://app.artemerge.org',
    development: 'http://localhost:5174'
  },
  
  // Main Shopify Site
  main: {
    production: 'https://artemerge.org',
    development: 'http://localhost:8080' // Shopify CLI dev server
  },
  
  // API Backend
  api: {
    production: 'https://api.artemerge.org',
    development: 'http://localhost:5051'
  }
};

// Get the appropriate base URL for current environment
const getBaseUrl = (service) => {
  return isProduction ? BASE_URLS[service].production : BASE_URLS[service].development;
};

// Centralized URL configuration
export const urls = {
  // React App URLs (dashboard, explore, account, etc.)
  app: {
    base: getBaseUrl('app'),
    dashboard: `${getBaseUrl('app')}/dashboard`,
    explore: `${getBaseUrl('app')}/explore`,
    account: `${getBaseUrl('app')}/account`,
    mentorship: `${getBaseUrl('app')}/mentorship`,
    marketplace: `${getBaseUrl('app')}/marketplace`,
    profile: `${getBaseUrl('app')}/profile`,
    upload: `${getBaseUrl('app')}/upload`,
    shipping: `${getBaseUrl('app')}/shipping`,
    login: `${getBaseUrl('app')}/login`,
    signup: `${getBaseUrl('app')}/signup`,
  },
  
  // Main Shopify Site URLs (public pages, collections, cart, etc.)
  main: {
    base: getBaseUrl('main'),
    home: `${getBaseUrl('main')}/`,
    collections: `${getBaseUrl('main')}/collections/original-artwork`,
    search: `${getBaseUrl('main')}/search`,
    cart: `${getBaseUrl('main')}/cart`,
    account: `${getBaseUrl('main')}/account`,
    about: `${getBaseUrl('main')}/pages/about`,
    contact: `${getBaseUrl('main')}/pages/contact`,
    terms: `${getBaseUrl('main')}/policies/terms-of-service`,
    privacy: `${getBaseUrl('main')}/policies/privacy-policy`,
  },
  
  // API URLs
  api: {
    base: getBaseUrl('api'),
  },
  
  // External URLs (always the same regardless of environment)
  external: {
    instagram: 'https://instagram.com/artemerge',
    twitter: 'https://twitter.com/artemerge',
    facebook: 'https://facebook.com/artemerge',
    linkedin: 'https://linkedin.com/company/artemerge',
  }
};

// Helper function to determine if a URL should open in the same tab or new tab
export const getLinkTarget = (url) => {
  const currentDomain = window.location.origin;
  const appDomain = getBaseUrl('app');
  const mainDomain = getBaseUrl('main');
  
  // If URL starts with current app domain, stay in same tab
  if (url.startsWith(appDomain)) {
    return '_self';
  }
  
  // If URL starts with main domain and we're in app, open new tab
  if (url.startsWith(mainDomain) && currentDomain === appDomain) {
    return '_blank';
  }
  
  // External URLs always open in new tab
  if (url.startsWith('http') && !url.startsWith(currentDomain)) {
    return '_blank';
  }
  
  return '_self';
};

// Helper function to get appropriate rel attribute
export const getLinkRel = (url) => {
  const target = getLinkTarget(url);
  return target === '_blank' ? 'noopener noreferrer' : undefined;
};

// Environment info for debugging
export const environmentInfo = {
  isDevelopment,
  isProduction,
  currentEnv: process.env.NODE_ENV,
  appBaseUrl: getBaseUrl('app'),
  mainBaseUrl: getBaseUrl('main'),
  apiBaseUrl: getBaseUrl('api'),
};

// Export individual URL categories for convenience
export const appUrls = urls.app;
export const mainUrls = urls.main;
export const apiUrls = urls.api;
export const externalUrls = urls.external;

export default urls; 